<template>
  <div class="bg-purple xzpadd10">
    <repay-detail-data-table
      :repayment-plan-list="repaymentPlanList"
      :repayment-execution-list="repaymentExecutionList"
      @doRepay = 'doRepay'
    />
    <el-dialog
      title="还款"
      :visible.sync="dialogVisible"
      width="60%"
    >
      <repay-form :form.sync="repayForm" ref="repayFormComponent"></repay-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="updateRepayPledgeFinancing">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import RepayDetailDataTable from '../../components/RepayDetailDataTable'
  import RepayForm from '../../components/RepayForm'
  import xhr from '../../../utils/xhr'

  export default {
    name: "ServerAdminFinancingRepay",
    data() {
      return {
        transactionId: this.$route.query['fi.transactionId'],
        repaymentPlanList: {
          data: [],
          count: 0
        },
        repaymentExecutionList: {
          data: [],
          count: 0
        },
        dialogVisible: false,
        repayForm: {}
      }
    },
    mounted() {
      this.getCustomerRepaymentPlanList( this.transactionId )
      this.getCustomerRepaymentExecutionList ( this.transactionId )
    },
    components: {
      RepayDetailDataTable,
      RepayForm
    },
    methods: {
      getCustomerRepaymentPlanList: function (transactionId = this.transactionId) {
        xhr.getCustomerRepaymentPlanList(
          {
            'plan.transactionId': transactionId,
            pageSize: 1000,
          },
          res=> {
            try {
              if(res.data.status == 'success') {
                this.repaymentPlanList = res.data
              }
            }catch (e) {

            }
          }
        )
      },
      getCustomerRepaymentExecutionList: function (transactionId = this.transactionId) {
        xhr.getCustomerRepaymentExecutionList(
          {
            're.transactionId': transactionId,
            pageSize: 1000,
          },
          res=> {
            try {
              if(res.data.status == 'success') {
                this.repaymentExecutionList = res.data
              }
            }catch (e) {

            }
          }
        )
      },
      //查询最近一期需要还款的信息
      getRepayPledgeFinancing: function (transactionId = this.transactionId) {
        xhr.getRepayPledgeFinancing(
          {
            're.transactionId': transactionId
          },
          res=> {
            try {
              if(res.data.status == 'success') {
                this.repayForm = Object.assign({}, res.data.data)
              }
            }catch (e) {

            }
          }
        )
      },
      //还款操作
      updateRepayPledgeFinancing: function() {
        this.$refs.repayFormComponent.$refs.repayForm.$refs.RepayForm.validate(valid=>{
          if(valid) {
            xhr.updateRepayPledgeFinancing(
              this.repayForm,
              res=> {
                try {
                  if(res.data.status == 'success') {
                    this.dialogVisible = false
                    this.getCustomerRepaymentPlanList()
                    this.getCustomerRepaymentExecutionList()
                  }
                }catch (e) {

                }
              }
            )
          }
        })
      },
      doRepay: function (index, row) {
        this.dialogVisible = true
        this.repayForm.re__sequenceNo = row.plan__sequenceNo
        this.getRepayPledgeFinancing()
      },
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/lender/ServiceAdmin/FinancingRepay.vue